
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/getlisted",
      function () {
        return require("private-next-pages/getlisted.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/getlisted"])
      });
    }
  